import { ReactNode } from "react";
import { GOI_PHONE } from "@/constants/contact";

interface ParlorFAQProps {
  companyName: string;
  telephone?: string;
  traffpublic?: string;
  binsoAverageCharge?: number;
  sigunguName: string;
}

export const ParlorFAQ = ({
  companyName,
  telephone,
  traffpublic,
  binsoAverageCharge,
  sigunguName,
}: ParlorFAQProps) => {
  const chargeText = binsoAverageCharge
    ? `빈소 평균 ${binsoAverageCharge.toLocaleString()}원`
    : "비용 안내 불가";

  const faqs: Array<{ question: string; answer: ReactNode }> = [
    {
      question: `${companyName} 빈소 예약은 어떻게 하나요?`,
      answer: (
        <>
          장례식장은 기본적으로 빈소 예약이 임종 이후 가능하다 보니 비용을 먼저
          확인하신 후 임종 시 이용 문의를 하시는 것이 합리적인 장례 준비에 더 큰
          도움이 됩니다. <b>고이장례연구소({GOI_PHONE})</b>
          에서 {companyName} 예상 비용을 지금 바로 안내받으실 수 있습니다.
        </>
      ),
    },
    {
      question: `${companyName} 장례 비용은 얼마인가요?`,
      answer: (
        <>
          {companyName} {chargeText} 수준이나, 실제 비용은 빈소
          규모·인원·용품·인력에 따라 달라집니다.{" "}
          <b>고이장례연구소({GOI_PHONE})</b>에서 항목 단위 투명 견적을 무료로
          안내해 드립니다.
        </>
      ),
    },
    {
      question: `${companyName} 전화번호와 위치는 어떻게 되나요?`,
      answer: (
        <>
          {companyName} 직통 번호는 <b>{telephone || "정보 없음"}</b>입니다.{" "}
          {sigunguName}에 위치하며, 위 지도에서 상세 위치를 확인하실 수
          있습니다.
        </>
      ),
    },
    {
      question: `${companyName} 대중교통으로 찾아가는 방법은?`,
      answer: traffpublic ? (
        <>{traffpublic}</>
      ) : (
        <>
          {companyName} 대중교통 정보는 고이장례연구소 상담(
          <b>{GOI_PHONE}</b>)을 통해 안내받으실 수 있습니다.
        </>
      ),
    },
    {
      question: `${sigunguName} 다른 장례식장과 비교하고 싶어요.`,
      answer: (
        <>
          고이장례연구소에서는 <b>{sigunguName} 인근 장례식장</b>의
          시설·비용·위치를 한눈에 비교해 드립니다. <b>{GOI_PHONE}</b>으로 연락
          주시면 무료로 비교 견적을 안내해 드립니다.
        </>
      ),
    },
  ];

  return (
    <section className="pd-section" id="pd-faq" aria-labelledby="pd-faq-title">
      <header className="pd-section__head">
        <div className="pd-section__title-block">
          <span className="pd-section__eyebrow">자주 묻는 질문</span>
          <h2 id="pd-faq-title">{companyName} 관련 FAQ</h2>
          <p className="pd-section__desc">
            {companyName}에 대해 자주 문의하시는 내용을 정리했습니다.
          </p>
        </div>
      </header>

      <div className="pd-faq" role="list">
        {faqs.map((faq, i) => (
          <details key={i} className="pd-faq-item" role="listitem">
            <summary>{faq.question}</summary>
            <div className="pd-faq-answer">{faq.answer}</div>
          </details>
        ))}
      </div>
    </section>
  );
};
